module.exports = __webpack_public_path__ + "static/media/SAMPLE MONEY.e3f03f4d.png";